import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  leave_register: [],
  error: null,
  message: '',
};

const MaternityBenefits = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_MATERNITY_BENEFITS_REQUEST:
    case actionTypes.DELETE_MATERNITY_BENEFITS_REQUEST:
    case actionTypes.UPLOAD_MATERNITY_BENEFITS_REQUEST:
    case actionTypes.MULTIDELETE_MATERNITY_BENEFITS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPDATE_MATERNITY_BENEFITS_SUCCESS:
    case actionTypes.DELETE_MATERNITY_BENEFITS_SUCCESS:
    case actionTypes.UPLOAD_MATERNITY_BENEFITS_SUCCESS:
    case actionTypes.MULTIDELETE_MATERNITY_BENEFITS_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_MATERNITY_BENEFITS_SUCCESS:
      return {
        ...state,
        loading: false,
        maternity_benefits: action.payload,

      }
    case actionTypes.GET_MATERNITY_BENEFITS_FAILURE:
    case actionTypes.UPDATE_MATERNITY_BENEFITS_FAILURE:
    case actionTypes.DELETE_MATERNITY_BENEFITS_FAILURE:
    case actionTypes.UPLOAD_MATERNITY_BENEFITS_FAILURE:
    case actionTypes.MULTIDELETE_MATERNITY_BENEFITS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default MaternityBenefits
